/**
 * Партиционирование clarify-experience кандидатов по результату E-Staff/internal check
 * перед стартом рассылки (TASKNEIROKLYUCH-434).
 *
 * Адаптирует структуру `{ messengerContacts: { hhResumeId, phone } }` к форме
 * `FullCandidate` ({ id, phone, email }) и переиспользует общий `filterBlockedCandidates`,
 * чтобы матчинг ключей совпадал во всех flow проекта (Релевантер ResultsTable, отклики
 * ResponsesTab). Параллельно возвращает оригинальные candidate + responseId через index.
 */

import { filterBlockedCandidates, CheckResult, FullCandidate } from './filterBlockedCandidates';

export interface ClarifyCandidate {
  messengerContacts?: {
    hhResumeId?: string | number | null;
    phone?: string | null;
    email?: string | null;
  } | null;
  email?: string | null;
  [key: string]: unknown;
}

export interface PartitionedClarifyResult<T> {
  /** Кандидаты, для которых можно стартовать диалог (пара: candidate + связанный responseId). */
  available: Array<{ candidate: T; responseId: string }>;
  /** В payload было хотя бы одно блокирующее правило. UI может использовать как сигнал «показать модалку». */
  hasBlocked: boolean;
}

interface AdaptedClarifyCandidate extends FullCandidate {
  _idx: number;
}

export function partitionClarifyCandidatesByCheck<T extends ClarifyCandidate>(
  candidates: T[],
  candidateResponseIds: string[],
  result: CheckResult,
): PartitionedClarifyResult<T> {
  const adapted: AdaptedClarifyCandidate[] = candidates.map((c, idx) => ({
    id: c.messengerContacts?.hhResumeId ?? null,
    phone: c.messengerContacts?.phone ?? null,
    email: c.email ?? c.messengerContacts?.email ?? null,
    _idx: idx,
  }));
  const availableAdapted = filterBlockedCandidates<AdaptedClarifyCandidate>(adapted, result);
  return {
    available: availableAdapted.map((a) => ({
      candidate: candidates[a._idx],
      responseId: candidateResponseIds[a._idx],
    })),
    hasBlocked: Array.isArray(result.blocked) && result.blocked.length > 0,
  };
}
